import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { TopBar } from "../components/UI";

const API = process.env.REACT_APP_API_URL || "https://g6fw4rjkvb.execute-api.eu-central-1.amazonaws.com/prototype";

export default function RoadRepLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const login = async () => {
    setLoading(true); setError("");
    try {
      const r = await fetch(`${API}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password, role: "road_rep" }),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || "Login failed");
      if (d.user?.role !== "road_rep") throw new Error("This login is for road representatives only.");
      localStorage.setItem("wine_route_token", d.token);
      navigate("/road-rep");
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#F2F5EC" }}>
      <TopBar title="Road Representative Login" />
      <div style={{ maxWidth: 400, margin: "60px auto", padding: "0 16px" }}>
        <div style={{ background: "white", borderRadius: 12, padding: 32, border: "1px solid #C4D0A8" }}>
          <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 22, color: "#1E2C14", margin: "0 0 24px" }}>
            Sign in
          </h2>
          {error && <div style={{ background: "rgba(139,26,47,0.08)", color: "#8B1A2F", padding: "10px 12px", borderRadius: 8, fontSize: 13, marginBottom: 16 }}>{error}</div>}
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 10, fontWeight: 600, color: "#6A7E58", textTransform: "uppercase", letterSpacing: "0.1em", display: "block", marginBottom: 4 }}>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)}
              style={{ width: "100%", padding: "9px 12px", borderRadius: 8, border: "1px solid #C4D0A8", background: "#EDF1E4", color: "#2C3820", fontSize: 13, boxSizing: "border-box" }} />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={{ fontSize: 10, fontWeight: 600, color: "#6A7E58", textTransform: "uppercase", letterSpacing: "0.1em", display: "block", marginBottom: 4 }}>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)}
              onKeyDown={e => e.key === "Enter" && login()}
              style={{ width: "100%", padding: "9px 12px", borderRadius: 8, border: "1px solid #C4D0A8", background: "#EDF1E4", color: "#2C3820", fontSize: 13, boxSizing: "border-box" }} />
          </div>
          <div style={{ textAlign: "right", margin: "-10px 0 16px" }}>
            <Link to="/forgot-password" state={{ email, role: "road_rep" }} style={{ fontSize: 12, color: "#8B1A2F", textDecoration: "none" }}>Forgot password?</Link>
          </div>
          <button onClick={login} disabled={loading || !email || !password}
            style={{ width: "100%", padding: "11px", borderRadius: 8, border: "none", background: "#8B1A2F", color: "white", fontWeight: 600, fontSize: 14, cursor: "pointer", opacity: (loading || !email || !password) ? 0.6 : 1 }}>
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </div>
      </div>
    </div>
  );
}
